export type GetUserDetailsFromRefIDResponse = {
  name: string;
  phone: string;
  email: string;
  [key: string]: string | number | null;
};

export type ForgotPasswordPayload = {
  countryCode?: string;
  phone?: string;
  email?: string;
  [key: string]: string | null | undefined;
};

export type ForgotPasswordResponse = {
  message: string;
  [key: string]: string | null;
};

export type SendOTPResponse = {
  verificationToken: string;
  phone: string;
  email: string;
  [key: string]: string | null;
};

export type VerifyOTPPayload = {
  otp: string;
  verificationToken: string;
};

export type VerifyOTPResponse = {
  token: string;
  id: number;
  role: string;
};

export type ResetPasswordPayload = {
  password: string;
  confirmPassword: string;
};

export type ResetPasswordSuccessResponse = {
  message: string;
};

export type SendLoginOTPPayload = {
  countryCode?: string;
  phone?: string;
  password: string;
  email?: string;
};

export type SendLoginOTPResponse = {
  verificationToken: string;
  phone: string;
  email: string;
};

export const SEND_LOGIN_OTP = 'SEND_LOGIN_OTP';
export const SEND_LOGIN_OTP_SUCCESS = 'SEND_LOGIN_OTP_SUCCESS';

export const TRIGGER_FORGOT_PASSWORD = 'TRIGGER_FORGOT_PASSWORD';
export const TRIGGER_FORGOT_PASSWORD_SUCCESS = 'TRIGGER_FORGOT_PASSWORD_SUCCESS';

export const GET_USER_DETAILS_FROM_REF_ID = 'GET_USER_DETAILS_FROM_REF_ID';
export const GET_USER_DETAILS_FROM_REF_ID_SUCCESS = 'GET_USER_DETAILS_FROM_REF_ID_SUCCESS';

export const SEND_OTP_FOR_REF_ID = 'SEND_OTP_FOR_REF_ID';
export const SEND_OTP_FOR_REF_ID_SUCCESS = 'SEND_OTP_FOR_REF_ID_SUCCESS';

export const VERIFY_OTP_FOR_REF_ID = 'VERIFY_OTP_FOR_REF_ID';
export const VERIFY_OTP_FOR_REF_ID_SUCCESS = 'VERIFY_OTP_FOR_REF_ID_SUCCESS';

export const RESET_PASSWORD_FOR_USER = 'RESET_PASSWORD_FOR_USER';
export const RESET_PASSWORD_FOR_USER_SUCCESS = 'RESET_PASSWORD_FOR_USER_SUCCESS';
